<template>
  <div id="app" ref="appbg">
    <!-- <img src="./assets/favicon.ico"> -->
    <div id="body">
      <!-- ref="vantaRef" -->
      <div id="header" ref="vantaRef">
        <div class="a_head">
          <span class="a" @click="to('https://www.guet.edu.cn')"
            >桂林电子科技大学</span
          >
          <span
            class="a"
            @click="to('https://www.guet.edu.cn/dept10/index.psp')"
            >材料与科学工程学院</span
          >
        </div>
        <div class="name">
          <img class="logo" :src="teamDetail.image" alt="" />
          <!-- <img :src="logotext503" alt="" /> -->
           <div class="GName">
              <div class="h1">{{ teamDetail.name }}</div>
              <div class="h2">{{ teamDetail.englishName }}</div>
           </div>
        </div>
        <div class="menu">
          <el-menu
            :default-active="activeIndex"
            mode="horizontal"
            @select="handleSelect"
            background-color="rgba(0,0,0,0)"
            text-color="#fff"
            active-text-color="#fff"
          >
            <el-menu-item
              v-for="item in page"
              :key="item.name"
              :index="item.name"
              v-show="!item.hidden"
            >
              <div class="twoLineText">{{ item.cn }}<br />{{ item.name }}</div>
            </el-menu-item>
            <!-- <el-submenu index="2">
              <template slot="title">我的工作台</template>
              <el-menu-item index="2-1">选项1</el-menu-item>
              <el-menu-item index="2-2">选项2</el-menu-item>
              <el-menu-item index="2-3">选项3</el-menu-item>
              <el-submenu index="2-4">
                <template slot="title">选项4</template>
                <el-menu-item index="2-4-1">选项1</el-menu-item>
                <el-menu-item index="2-4-2">选项2</el-menu-item>
                <el-menu-item index="2-4-3">选项3</el-menu-item>
              </el-submenu>
            </el-submenu> -->
            <!-- <el-menu-item index="3" disabled></el-menu-item> -->
            <!-- <el-menu-item index="4"
              ><a href="https://www.ele.me" target="_blank"
                >订单管理</a
              ></el-menu-item
            > -->
          </el-menu>
        </div>
      </div>

      <div id="main" >
        <router-view/>
      </div>
      <div id="footer">
        <div class="copyright">
          有机光电材料与器件团队 ©版权所有
          <div class="en">
            Copyright© Jian Zhang's Group , All Rights Reserved
          </div>
          <div class="en">
            <a style="color: #fff;" href="http://beian.miit.gov.cn/">黑ICP备2025036339号</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import logo from '@/images/logo.png'
import logotext503 from '@/images/logo_text_503.png'
import * as THREE from 'three'
// import waves from 'vanta/src/vanta.globe'
import bg from 'vanta/src/vanta.waves'
import {getTeamDetail} from '@/api/api'
export default {
  name: 'App',
  mounted () {
    // this.vantaEffect = waves({
    //   el: this.$refs.appbg,
    //   THREE: THREE,
    //   color: 0x556B2F,
    //   color2: 0x556B2F,
    //   size: 2.70,
    //   backgroundColor: 0x2F4F4F,
    //   mouseControls: false,
    //   showDots: false
    // })
    this.vantaEffect = bg({
      el: this.$refs.vantaRef,
      THREE: THREE,
      color: 0x1A3D3D,
      color2: 0x1A3D3D,
      backgroundColor: 0x1A3D3D,
      points: 8.00,
      spacing: 20.00,
      maxDistance: 24.00
    })
  },
  beforeDestroy () {
    if (this.vantaEffect) {
      this.vantaEffect.destroy()
    }
  },
  watch: {
    $route (to, from) {
      // 当路由变化时执行的代码
      console.log('Route changed from', from.path, 'to', to.path)
      // 你可以在这里根据路由变化更新数据等
      this.activeIndex = to.name
      // this.vantaEffect = waves({
      //   el: this.$refs.appbg,
      //   THREE: THREE,
      //   color: 0x556B2F,
      //   color2: 0x556B2F,
      //   size: 2.70,
      //   backgroundColor: 0x2F4F4F,
      //   mouseControls: false,
      //   showDots: false
      // })
    }
  },
  data () {
    return {
      logo,
      logotext503,
      activeIndex: 'Home',
      page: [],
      teamDetail: {}
    }
  },
  created () {
    console.log(this.$router)
    this.page = this.$router.options.routes
    this.activeIndex = this.$router.history.current.name
    this.getTeamDetail()
  },
  methods: {

    getTeamDetail () {
      getTeamDetail().then(res => {
        if (res.code === 200) {
          this.teamDetail = res.data
        }
      })
    },
    to (http) {
      window.location.href = http
    },
    handleSelect (key, keyPath) {
      console.log(key)
      this.activeIndex = key
      this.page.filter((item) => {
        return item.name === key
      })
      let topath = this.page.filter((item) => {
        return item.name === key
      })
      if (topath[0]) {
        this.$router.push(topath[0].path)
      }
    }
  }
}
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  /* -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale; */
  /* text-align: center; */
  color: #2c3e50;
  /* margin-top: 60px; */
  background: #2F4F4F;
  /* background-size: 100%; */
  height: 100%;
  min-width: 1160px;
}
#body {
  width: 1160px;
  background: rgba(255, 0, 0, 0.1);
  overflow: hidden;
  margin: 0 auto;
  box-sizing: border-box;

}
#header {
  /* background: url(./images/header_bg.jpg) #f0f0f0 repeat-x top center; */
  height: 240px;
  width: 1160px;
}
</style>
<style scoped>
.a_head {
  /* height: 40px; */
  padding: 10px 20px;
  background: linear-gradient(
    to right,
    rgba(0, 0, 0, 0.3),
    rgba(0, 0, 0, 0)
  );
  color: #fff;
}
.a {
  transition: 0.2s;
  font-size: 14px;
}
.a + .a {
  padding-left: 40px;
}
.a:hover {
  cursor: pointer;
  color: #D4AF37;
}
.name {
  width: 100%;
  height: 140px;
  display: flex;
  align-items: center;
  padding: 0 20px;
  box-sizing: border-box;
}
.menu {
  background: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.3));
}
.el-menu-item:hover {
  background-color: rgba(0, 0, 0, 0.3) !important; /* 设置 hover 背景颜色 */
}
.twoLineText {
  line-height: 20px !important;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.logo{
  height: 120px;
}
#main {
  background: #fff;
  width: 1160px;
  min-height: calc(100vh - 355px);
  overflow: hidden;
  padding: 20px;
  box-sizing: border-box;
}
#footer{
  background: #1A3D3D;
  /* line-height: 24px; */
  color: #fff;
  font-size: 14px;
  padding: 20px;
}
.en{
  margin-top: 10px;
}
.h1{
  font-size: 40px;
  color: #fff;
  font-weight: 600;
  font-family: 'Times New Roman';
  letter-spacing: 5px;
}
.h2{
  color: #D4AF37;
  font-size: 13px;
  letter-spacing: 2px;
}
.GName{
  margin-left: 20px;
}
.is-active{
  border-bottom-color: #D4AF37!important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue